import {Component, Input} from '@angular/core';
import {NotificationDto} from '../../../../Models/Notification/notification.interface';

@Component({
  selector: 'app-notification-item',
  templateUrl: './notification-item.component.html',
  styleUrls: ['./notification-item.component.scss'],
  standalone: false
})
export class NotificationItemComponent {
  @Input() item!: NotificationDto;
}
